import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconMinusLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.25 12.75a.725.725 0 0 1-.534-.216A.726.726 0 0 1 5.5 12c0-.213.072-.391.216-.534a.725.725 0 0 1 .534-.216h11.5c.212 0 .39.072.534.216A.726.726 0 0 1 18.5 12a.722.722 0 0 1-.216.534.726.726 0 0 1-.534.216H6.25Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconMinusLine;
